import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { GameSmall } from '../Game/GameSmall.jsx'

export class MojCasinoPobjedniciDana extends React.Component {

    constructor(props) {
        super(props);

        this.state = { pobjednici: null };

        this.fetchData = this.fetchData.bind(this);
        this.setData = this.setData.bind(this);

        this.fetchData();
    }


    fetchData() {
        var promises = Promise.all([casino.repos.pobjedniciDanaRepo.list()]);

        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setData, function (reason) { });
    }

    componentWillUnmount() {
        if (this.dataPromises)
            this.dataPromises.cancel();
    }

    setData(data) {
        this.setState({
            pobjednici: data[0]
        });
    }

    shouldComponentUpdate() {
        if (this.state.pobjednici && this.props.igre)
            return false;

        return true;
    }


    componentDidUpdate() {

        if (this.state.pobjednici && this.props.igre)
            casino.utils.lazyImages.mountEventLazyLoadImages();
    }



    render() {
        return <div className="pobjednici-line moj-casino-line" id={this.props.from}>
            <h2 className="homepage-margin2">Pobjednici dana</h2>

            {this.props.igre && this.state.pobjednici && this.state.pobjednici.map((x, i) => {
                var igra = this.props.igre.filter(y => y.s == x.igraSifra)[0];

                if (igra) {
                    return <div className="mojcasino-padding" key={i}>
                        <div className=" game-item game-item2 game-item3">
                            <GameSmall
                                categories={this.props.categories}
                                showGameName={false}
                                from={this.props.from}
                                igra={igra}
                                showJackpot={false}
                                extraClass={""}
                                goLazyImage={true}
                                iconImage={true}
                                brands={this.props.brands}
                                // GamePosition podaci, HizmanB
                                PageName={this.props.PageName}
                                GamePosition={i + 1}
                                PositionType={this.props.PositionType}
                                ComponentName={this.props.ComponentName}
                                ComponentPosition={this.props.ComponentPosition}
                                IsIcon={this.props.IsIcon}
                                TabName={this.props.TabName }
                                TabPosition={this.props.TabPosition }
                            ></GameSmall>



                        </div>
                        <div style={{ width: '5px' }}></div>
                        <div className="pobjednik-dana">
                            <span className="pobjednik text-ellipsis ">{casino.utils.capitalizeFirstLetter(x.igrac)}</span>
                            <div className="iznos text-ellipsis">{casino.utils.numberWithCurrencyFromated(x.dobitak, x.valuta)}
                            </div>
                        </div>
                    </div>
                }

                return null;
            }
            ).filter(x => x != null).slice(0, 4)}
        </div>




    }


};
